<div class="example-container mat-elevation-z2">
  <form [formGroup]="form">
    <mat-table #table [dataSource]="dataSource">
      @for (column of config; track column) {
        <ng-container
          [cdkColumnDef]="column.property"
          >
          <mat-header-cell *cdkHeaderCellDef>{{ column.header }}</mat-header-cell>
          <mat-cell *cdkCellDef="let row; let idx = index">
            @if (column.role === true) {
              <ca-role-select
                mode="dropdown"
                [formControl]="controlForCell(idx, column.property)"
              ></ca-role-select>
            }
            @if (column.isBoolean === true) {
              <div>
                @if (column.isBoolean === true) {
                  <mat-slide-toggle
                    [formControl]="controlForCell(idx, column.property)"
                    [disabled]="hasAccessAllCustomersProperty(idx)"
                    >
                  </mat-slide-toggle>
                }
              </div>
            }
            @if (!column.role && !column.isBoolean) {
              <mat-form-field>
                <input
                  type="text"
                  matInput
                  [formControl]="controlForCell(idx, column.property)"
                  [value]="row[column.property] || null"
                  />
              </mat-form-field>
            }
          </mat-cell>
        </ng-container>
      }
      <ng-container cdkColumnDef="action">
        <mat-header-cell *cdkHeaderCellDef>Action</mat-header-cell>
        <mat-cell *cdkCellDef="let row; let idx = index">
          @if (!results) {
            <button
              (click)="removeAt(idx)"
              [disabled]="loading"
              role="button"
              color="warn"
              ca-action-button
              >
              Remove
            </button>
          }
        </mat-cell>
      </ng-container>
      <ng-container cdkColumnDef="result">
        <mat-header-cell *cdkHeaderCellDef></mat-header-cell>
        <mat-cell class="result-cell" *cdkCellDef="let row; let idx = index">
          @if (results) {
            <ca-row-result
              [ok]="!results[idx]?.hasErrors"
              [result]="results[idx]"
            [messages]="{
              ok: 'Imported OK',
              error: flattenError(results[idx]),
              locationOk: 'Found Location',
              locationError: 'Could not find location'
            }"
            ></ca-row-result>
          }
        </mat-cell>
      </ng-container>
      <mat-header-row
        *cdkHeaderRowDef="displayedColumns | async"
      ></mat-header-row>
      <mat-row *cdkRowDef="let row; columns: displayedColumns | async">
      </mat-row>
    </mat-table>
  </form>
</div>
